import { i18n } from '../services/localization'
import { container } from '../services/container'

export const errorStore = {
	state: {
    	message: null,
    	type: null,
    	show: true
	},

	hide () {
		this.state.show = false
	},

	show () {
		this.state.show = true
	},

	formatMessage (response, params) {
		this.state.message = this.format(response, params)
		this.show()
	},

	updateMessage (response) {
		this.state.message = response
		this.show()
	},

	removeMessage () {
		this.state.message = null
		this.state.type = 'error'
		this.hide()
	},

	updateType (type) {
		this.state.type = type
	},

	formatKeyMessage (key, params) {
		return i18n.te('api.'+key) ? i18n.t('api.'+key, params) : key;
	},
	format (response, params) {
		if (!response) return

		if (response instanceof Error) {
			return i18n.t(`api.${response.message.toLowerCase().replace(/\s+/g, '_')}`, params)
		}

		if (response.message) {
			return response.message
		}

		if (!response.body) return 

		if (response.body.errors) {
			if (response.body.errors[0].code.toLowerCase() === 'error') {
				return response.body.errors[0].message
			}
			return i18n.t(`api.${response.body.errors[0].code.toLowerCase()}`, params)
		}

		if (response.body.code) {
			if (typeof response.body.code === 'number') {
				this.bugsnagNotify(response)
				return `Error ${response.body.code}. Something went wrong`
			}

			if (response.body.code.toLowerCase() === 'error') {
				return response.body.message
			}

			return i18n.t(`api.${response.body.code.toLowerCase()}`, params)
		}

		if (response.body.message) {
			return i18n.t(`api.${response.body.message.toLowerCase().replace(/\s+/g, '_')}`, params)
		}

		return 'Something went wrong'			

	},

	bugsnagNotify (response) {
		if (container && container.get('bugsnagClient')) {
			var bugsnagClient = container.get('bugsnagClient')
			bugsnagClient.notify(new Error(`Failed ${response.url}: ${response.body.code} - ${response.body.message}`))
		}
	}
}